import { TEmAutomationAssignedScript } from 'redux/reducers/emAutomationScripts/types';
import { TTableStructure, ETableStructureType, ETableStructureAlign } from 'ui/EasTable/types';
import { EIconButtons } from 'ui/EasTable/EasTableRow/EasTableValue/constants';

export const tableStructure: TTableStructure<keyof TEmAutomationAssignedScript>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Name',
		selector: 'shortDescription',
		show: true,
		sortable: false,
		filterable: true,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Description',
		selector: 'description',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 4,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Added At',
		selector: 'createdAt',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Added By',
		selector: 'author',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 2,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		selector: 'id',
		noName: true,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.CENTER,
		buttons: [
			{
				name: 'Delete',
				icon: EIconButtons.DELETE,
			},
		],
	},
];
